import { DuckWall } from "./DuckWall";

// Wall behind, one glass card on the left with the brand and the current step.
export const LoginShell = ({ gated, children }) => (
  <div data-testid="login-page" className="relative min-h-screen overflow-hidden">
    <DuckWall />
    <main className="relative z-10 flex min-h-screen items-center px-5 py-10 sm:px-10 lg:px-20">
      <section className="w-full max-w-md login-card-in">
        <div className="mb-8 flex items-center gap-3">
          <img src="/zdg-logo.png" alt="" className="h-10 w-10 rounded-xl object-contain bg-white p-1 shadow-sm" />
          <span className="font-heading text-xl font-bold tracking-tight text-[#1f1f24]">Duckify</span>
          {gated && (
            <span data-testid="login-coming-soon-badge" className="ml-1 rounded-full bg-[#1f1f24] px-3 py-1 text-[11px] font-bold uppercase tracking-[0.18em] text-[#ffc700]">
              Coming soon
            </span>
          )}
        </div>
        <div data-testid="login-card" className="theme-light rounded-[28px] border border-white/70 bg-white/80 p-7 shadow-[0_30px_60px_-30px_rgba(60,40,10,0.5)] backdrop-blur-xl sm:p-9">
          {children}
        </div>
      </section>
    </main>
  </div>
);

export const StepTitle = ({ title, children }) => (
  <div className="mb-6">
    <h1 className="font-heading text-3xl sm:text-4xl font-bold leading-tight tracking-tight text-[#1f1f24]">{title}</h1>
    {children && <p className="mt-3 text-sm sm:text-base text-[#5a554b]">{children}</p>}
  </div>
);
